var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTrash(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.22989 1.23558C3.90326 1.23558 3.63695 1.50109 3.63695 1.83205C3.63695 2.12444 3.39992 2.36146 3.10754 2.36146C2.81515 2.36146 2.57812 2.12444 2.57812 1.83205C2.57812 0.920657 3.31416 0.176758 4.22989 0.176758H7.42048C8.33404 0.176758 9.07577 0.91849 9.07577 1.83205C9.07577 2.12444 8.83875 2.36146 8.54636 2.36146C8.25397 2.36146 8.01695 2.12444 8.01695 1.83205C8.01695 1.50326 7.74927 1.23558 7.42048 1.23558H4.22989Z",
    fill: "#545C62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.54042 3.35472C1.83162 3.32842 2.089 3.54316 2.1153 3.83436L2.70834 10.4002C2.72655 10.6065 2.89964 10.7643 3.10569 10.7643H8.54098C8.74702 10.7643 8.92012 10.6065 8.93832 10.4002L8.93842 10.3991L9.53136 3.83436C9.55766 3.54316 9.81505 3.32842 10.1063 3.35472C10.3975 3.38102 10.6122 3.63841 10.5859 3.92961L9.99305 10.4932C9.99302 10.4935 9.99299 10.4939 9.99296 10.4942C9.92601 11.2474 9.29462 11.8232 8.54098 11.8232H3.10569C2.35193 11.8232 1.72046 11.2472 1.65367 10.4938C1.65365 10.4936 1.65364 10.4934 1.65362 10.4932L1.06077 3.92961C1.03447 3.63841 1.24921 3.38102 1.54042 3.35472Z",
    fill: "#545C62"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.58801 3.70605C4.88039 3.70605 5.11742 3.94308 5.11742 4.23547V9.17664C5.11742 9.46903 4.88039 9.70605 4.58801 9.70605C4.29562 9.70605 4.05859 9.46903 4.05859 9.17664V4.23547C4.05859 3.94308 4.29562 3.70605 4.58801 3.70605Z",
    fill: "#545C62"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.06066 3.70605C7.35305 3.70605 7.59007 3.94308 7.59007 4.23547V9.17664C7.59007 9.46903 7.35305 9.70605 7.06066 9.70605C6.76828 9.70605 6.53125 9.46903 6.53125 9.17664V4.23547C6.53125 3.94308 6.76828 3.70605 7.06066 3.70605Z",
    fill: "#545C62"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.707031 2.18469C0.707031 1.8923 0.944057 1.65527 1.23644 1.65527H10.4129C10.7053 1.65527 10.9423 1.8923 10.9423 2.18469C10.9423 2.47707 10.7053 2.7141 10.4129 2.7141H1.23644C0.944057 2.7141 0.707031 2.47707 0.707031 2.18469Z",
    fill: "#545C62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTrash);
export default __webpack_public_path__ + "static/media/ic_trash.39963de8beaaaa0f1d05cd59fb919f50.svg";
export { ForwardRef as ReactComponent };